// react
import { useContext, useState } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// types
import { Benefit, Pagination } from '../../../../../@types';

// router
import { useSearchParams } from 'react-router-dom';

// context
import { ContextUserEntity } from '../../../../../App.context';
import { ContextProject } from '../../Project.context';

// hooks
import { useFetch } from '../../../../../hooks/useFetch';

// mui
import { Container, Grid, Paper, Typography } from '@mui/material';

// forms
import { FormAddBenefit } from '../../../../forms/FormAddBenefit/FormAddBenefit';

// tables
import { TableBasicBenefits } from '../../../../tables/basic/TableBasicBenefits/TableBasicBenefits';

// utils
import { defaultPagination } from '../../../../../utils/defaults';

export const Benefits = () => {
	// session
	const accessToken = sessionStorage.getItem('accessToken');
	const idToken = sessionStorage.getItem('idToken');

	// hooks
	const [searchParams] = useSearchParams();
	const { t } = useTranslation();

	// context
	const { project } = useContext(ContextProject);
	const { userEntity } = useContext(ContextUserEntity);

	// params
	const paramPage = Number(searchParams.get('page') || 1);

	// state
	const [benefits, setBenefits] = useState<Benefit[]>([]);
	const [pagination, setPagination] = useState<Pagination>({
		...defaultPagination,
		perPage: 5,
	});

	// fetch benefits
	let urlBenefits = `${process.env.REACT_APP_API_URL}/benefits?project=${project?.id}&page=${paramPage}&limit=${pagination.perPage}`;

	if (userEntity) {
		urlBenefits += `&entity=null,${userEntity.id}`;
	}

	const { isLoading, refetch: refetchBenefits } = useFetch({
		isEnabled: Boolean(project),
		url: urlBenefits,
		options: {
			headers: {
				Authorization: `Bearer ${accessToken}`,
				User: String(idToken),
			},
		},
		onSuccess: (res) => {
			if (res.data) {
				setBenefits(res.data);
			}

			if (res.pagination) {
				setPagination(res.pagination);
			}
		},
	});

	return (
		<Container maxWidth={false}>
			<Grid container spacing={2}>
				<Grid item xs={12} lg={4}>
					<Paper
						sx={(theme) => {
							return {
								padding: theme.spacing(2),
								height: '100%',
								minHeight: {
									lg: 400,
								},
							};
						}}>
						<Grid container spacing={2}>
							<Grid item xs={12}>
								<Typography variant="h3">{t('addBenefit')}</Typography>
							</Grid>
							<Grid item xs={12}>
								<FormAddBenefit
									onSuccess={() => {
										refetchBenefits();
									}}
								/>
							</Grid>
						</Grid>
					</Paper>
				</Grid>
				<Grid item xs={12} lg={8}>
					<Paper
						sx={(theme) => {
							return {
								padding: theme.spacing(2),
								height: '100%',
							};
						}}>
						<Grid
							alignItems="stretch"
							container
							direction="column"
							spacing={2}
							sx={{ height: 'calc(100% + 16px)' }}>
							<Grid item>
								<Typography variant="h3">{t('benefits')}</Typography>
							</Grid>
							<Grid item flex={1}>
								<TableBasicBenefits
									borderRadius={2}
									color="grey"
									data={benefits}
									hasBorder={true}
									hasStripes={true}
									isLoading={isLoading}
									refetchBenefits={refetchBenefits}
									TableFooterProps={{
										numShowing: benefits.length,
										pagination,
									}}
								/>
							</Grid>
						</Grid>
					</Paper>
				</Grid>
			</Grid>
		</Container>
	);
};
